import { PartnerLogDialog } from 'legacy/lut/components/widgets/public/partnerLogButton/PartnerLogDialog'
import React from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { Actions } from 'core-components/library/modalDialog'

import styles from './PartnerLogButton.module.scss'

export const PartnerLogButton = (props: any) => {
  const [showDialog, setShowDialog] = React.useState(false)

  return (
    <div className={styles.root}>
      <div>
        <Button onClick={() => setShowDialog(true)}>{props.caption}</Button>

        <ModalDialog
          show={showDialog}
          onClose={() => setShowDialog(false)}
          size={'xl'}
          content={PartnerLogDialog}
          contentProps={{
            partnerID: props.partnerID,
            createdByEmailFilter: props.createdByEmailFilter,
            onClose: () => setShowDialog(false),
          }}
          title={'Audit trail'}
          header={() => (
            <Actions
              position={'end'}
              items={[
                {
                  id: 'close',
                  label: 'OK',
                  onClick: () => setShowDialog(false),
                },
              ]}
            />
          )}
        />
      </div>
    </div>
  )
}
